import api from 'service/api'

const dponetAPI = api.create('dponet')

const postTheme = async (privacyPortalTheme) => {
  return await dponetAPI.post(`/privacy_portal/theme`, { privacyPortalTheme })
}

const getTheme = async () => {
  return await dponetAPI.get(`/privacy_portal/theme`)
}

export default {
  getTheme,
  postTheme,
}
